import React from 'react';
import { Mail, Instagram } from 'lucide-react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-muted border-t border-border">
      <div className="container mx-auto px-4 py-12 lg:py-16">
        <div className="flex flex-col items-center gap-6 md:flex-row md:items-start md:justify-between">
          {/* Brand + tagline */}
          <div className="text-center md:text-left">
            <span className="font-display text-base lg:text-lg font-semibold tracking-[0.25em] uppercase text-foreground block">
              GLOW LAB
            </span>
            <p className="text-sm text-muted-foreground italic mt-2">
              L'alliance de la rigueur système et de la liberté créative.
            </p>
          </div>

          {/* Contact links */}
          <div className="flex items-center gap-5">
            <a
              href="mailto:tina@majoliepeau.com"
              className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors duration-300"
              aria-label="Email"
            >
              <Mail className="w-4 h-4" strokeWidth={1.5} />
              <span className="hidden sm:inline">tina@majoliepeau.com</span>
            </a>
            <a
              href="https://instagram.com/majolie_peau"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors duration-300"
              aria-label="Instagram"
            >
              <Instagram className="w-4 h-4" strokeWidth={1.5} />
              <span className="hidden sm:inline">@majolie_peau</span>
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-10 pt-6 border-t border-border">
          <p className="text-xs text-muted-foreground text-center md:text-left">
            © {currentYear} Glow Lab. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
